import { h } from '@stencil/core';
import cn from 'classnames';
import { pesIconMirrorDirection, pesIconSizes } from '@pes-ui/utils';
export class ActionBlock {
  constructor() {
    this.heading = undefined;
    this.url = undefined;
    this.text = undefined;
    this.icon = 'segment_retail';
    this.size = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("pes-banner", { url: this.url, icon: this.icon }, h("div", { class: cn('action-block', { 'action-block--small': this.size === 'small' }) }, h("h3", { class: "action-block__heading", innerHTML: this.heading }), h("span", { class: "action-block__text-content" }, h("span", { class: "action-block__text", innerHTML: this.text }), h("pes-icon", { class: "action-block__text-arrow-icon", size: pesIconSizes.NANO, mirror: pesIconMirrorDirection.HORIZONTAL }, "arrow2_left")))));
  }
  static get is() { return "pes-action-block"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["action-block.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["action-block.css"]
    };
  }
  static get properties() {
    return {
      "heading": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "Products from A to Z"
            }],
          "text": "Action heading."
        },
        "attribute": "heading",
        "reflect": false
      },
      "url": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "http://some.domain/some/path#some-hash?some=query"
            }],
          "text": "URL for redirection after click."
        },
        "attribute": "url",
        "reflect": false
      },
      "text": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "View product list"
            }],
          "text": "Additional text below the heading."
        },
        "attribute": "text",
        "reflect": false
      },
      "icon": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "segment_retail"
            }],
          "text": "Icon at the top left corner."
        },
        "attribute": "icon",
        "reflect": false,
        "defaultValue": "'segment_retail'"
      },
      "size": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "TSize",
          "resolved": "\"\" | \"small\"",
          "references": {
            "TSize": {
              "location": "local",
              "path": "/opt/actions-runner/_work/website-components/website-components/src/components/pes-all-products/action-block/action-block.tsx"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "size",
        "reflect": false
      }
    };
  }
  static get elementRef() { return "el"; }
}
